import _ from 'lodash';

export function trimPayload (payload) {
    if (_.isPlainObject(payload)) {
        return _.transform(payload, (result, value, key) => {
            result[key] = trimPayload(value);
            return result;
        });
    } else if (Array.isArray(payload)) {
        return payload.map((item) => trimPayload(item));
    } else if (_.isString(payload)) {
        return payload.trim();
    } else {
        return payload;
    }
}
